module.exports = __webpack_public_path__ + "img/蒙版组33@2x.412cef2b.png";